import { WrappedFieldProps } from 'redux-form';
import * as React from 'react';
import DatePicker from 'react-datepicker';
import * as moment from 'moment';
import FaCalendarO from 'react-icons/fa/calendar';

const DATE_FORMAT = 'DD/MM/YYYY';

interface IAlternativeDatePickerOwnProps {
    minDate?: moment.Moment;
    maxDate?: moment.Moment;
    placeholder?: string;
    onValueChange?: (newValue: string) => void;
}

type Props = WrappedFieldProps & IAlternativeDatePickerOwnProps;

const AlternativeDatePicker: React.SFC<Props> = ({
        input,
        placeholder,
        meta: { touched, error },
        onValueChange,
        ...props,
}) => {
    const handleChange = (date: any) => {
        const momentDate = moment(date);
        const newValue = momentDate.isValid() ? momentDate.format(DATE_FORMAT) : '';

        input.onChange(newValue);

        if (onValueChange) {
            onValueChange(newValue);
        }
    };

    return (
      <div className={touched && error ? 'has-error' : ''}>
        <div className="icon-cal">
          <DatePicker
              {...props}
              locale="en-gb"
              customInput={<FaCalendarO />}
              placeholderText={placeholder}
              dateFormat={DATE_FORMAT}
              selected={input.value ? moment(input.value, DATE_FORMAT) : null}
              onChange={handleChange}
          />
        </div>
      </div>
  );
};

export default AlternativeDatePicker;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/components/AlternativeDatePicker/index.tsx